import React, { useContext, useEffect, useState } from "react";
import discount from "../../assets/discount.png";
import { Link } from "react-router-dom";
import WOW from 'wowjs';
import {cartContext}from'../Contexts/CartContext';
export default function Product({ products }) {

  let {setProductInCart,loading,disable,setloading,setdisable}=useContext(cartContext);
  const [myId, setmyId] = useState(null);


  function addToCart(id) {
 
  setmyId(id);

   setProductInCart(id);

     

    
 }

  const wow= new WOW.WOW();

  useEffect(() => {
  
        wow.init();



    ;
}, [])
  return <>
    
      {products.map((item,indx) => {
        return<div  key={item._id} className="col-lg-3 col-sm-6 ">
       
          <div className=" product " style={{height:350}} >
          <Link to={`/ProductDetails/${item._id}`}>
        {item.priceAfterDiscount?<div className="iconDiscount " ><img src={discount} className="w-100 wow animate__animated animate__backInDown animate__delay-2s 	 animate__slow" style={{height:85}} /> </div>:''}  
            <img src={item.imageCover} alt="product" className="w-100 h-50 productImg" />
            <p className="text-main ps-2 mt-1">{item.subcategory.title}</p>
            <p className="fw-bold ps-2">{item.title.split(' ').slice(0.2).join(" ")}</p>
            <div className="overflow-hidden ">{item.priceAfterDiscount?<span className=" float-start ms-2"><del>{item.price} EGP</del> {item.priceAfterDiscount} EGP</span>:<span className=" float-start ms-2">{item.price} EGP</span>}<span className=" float-end me-2"><i className="fa-solid fa-star text-warning me-2"></i>{item.ratingsAverage}</span></div>
          
          </Link>
          <button type="button " className="btn bg-main w-100 mt-2 " disabled={loading&&disable} onClick={()=>{
            addToCart(item._id)
          }}>{loading&&disable&&myId==item._id?<span className="spinner-border spinner-border-sm"></span>:'Add Product'}</button></div>

        </div>
        
      })
      
      
      }
      
    
  </>
}
